//ログアウト処理
import React from 'react';
import AuthProvider from '../utilities/authProvider';

export class logout extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    AuthProvider.instance.logout();
  }

  render() {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/logout.jsx